//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WX_API from '@/utils/wx_api'
export default {
    options: {
        virtualHost: true
    },
    props: {
        can_add: Boolean,
        msg_tools_id: String,
        msg: Object
    },
    methods: {
        copy () {
            this.$emit('hide')
            WX_API.setClipboardData(this.msg.content)
        },
        addExpression () {
            this.$emit('hide')
            this.$emit('addExpression', this.msg.content)
        }
    }
}
